export default {"src":"/_next/static/media/shield-key.8cd5d4ee.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};